import {OrganisationDTO} from "../../../../DTO/Organisation/OrganisationDTO";

export class KeycloakUserEntity {
    id:string;
    createdDate : Date;
    first_name:string;
    last_name:string;
    email:string;
    organisation_id:string;
    email_verified:boolean;
    enabled:boolean;
    realm:string;
    roles:string;

    // @Transient
    createFailMessage: string;

    constructor(data?: Partial<KeycloakUserEntity>) {
        if (data) {
            this.bindData(data);
        }
    }

    bindData(data: Partial<KeycloakUserEntity>): void {
        if (data) {
            this.id = data.id;
            this.createdDate = data.createdDate;
            this.first_name = data.first_name;
            this.last_name = data.last_name;
            this.email = data.email;
            this.organisation_id = data.organisation_id;
            this.email_verified = data.email_verified;
            this.enabled = data.enabled;
            this.realm = data.realm;
            this.roles = data.roles;
            this.createFailMessage = data.createFailMessage;
        }
    }
}
